import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss']
})
export class SkeletonComponent implements OnInit {

  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  @Input()
  height: string = '.5rem';

  @Input()
  width: string = '100%';

  @Input()
  radius: string = '4px';

  @Input()
  margin: string = '0';

  @Input()
  mobileWidth: string = '100%';

  constructor(
    public breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
  }

}
